import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

import { useFlags } from 'flags'
import { capitalize } from '../../../utils/strings'
import { setActiveTab, getActiveTab } from '../../../ducks/editor/tabs'
import { getSelection } from '../../../ducks/editor/selection'
import Icon from '../../Shared/Icon'
import {
  ADD,
  BRANDING,
  DATA,
  SCREENS,
  SETTINGS,
  PUBLISH,
  ANALYTICS,
  VERSIONS,
} from '../../../utils/tabs'

import './LeftNav.css'

const items = [
  { type: BRANDING, icon: 'branding' },
  { type: SCREENS, icon: 'layers' },
  { type: DATA, icon: 'data' },
  { type: SETTINGS, icon: 'settings' },
  { type: PUBLISH, icon: 'done-all' },
  { type: ANALYTICS, icon: 'analytics' },
]

const LeftNav = props => {
  const { history, match, selection } = props
  const { hasDesignVersioning } = useFlags()

  const allItems = [...items]

  if (hasDesignVersioning) {
    allItems.push({ type: VERSIONS, icon: 'versions' })
  }

  const getActiveTab = () => {
    let { activeTab } = props

    if (selection.length > 0) activeTab = null

    return activeTab
  }

  const handleClick = tabName => {
    const { setActiveTab } = props
    const { appId } = match.params
    const activeTab = getActiveTab()

    if (!tabName) return null

    switch (tabName) {
      case DATA:
        history.replace(`/apps/${appId}/data`)

        break
      case SETTINGS:
        history.replace(`/apps/${appId}/app-settings`)

        break
      case VERSIONS:
        history.replace(`/apps/${appId}/versions`)

        break
      default:
        history.replace(`/apps/${appId}/screens`)
    }

    if (tabName === activeTab && selection.length === 0) {
      return setActiveTab(null)
    }

    return setActiveTab(tabName)
  }

  const activeTab = getActiveTab()

  return (
    <div className="editor-left-nav">
      <AddButton onClick={handleClick} active={activeTab === ADD} />
      {allItems.map(itm => (
        <LeftNavItem
          {...itm}
          key={itm.type}
          active={activeTab === itm.type}
          onClick={handleClick}
        />
      ))}
    </div>
  )
}

class LeftNavItem extends Component {
  handleClick = () => {
    const { type, onClick } = this.props

    onClick(type)
  }

  render() {
    let { icon, type, active } = this.props

    let tooltip = type
    if (type === 'data') tooltip = 'Database'
    else if (type === 'versions') tooltip = 'Version History'

    if (icon === 'layers') icon = 'screens'
    if (type === 'versions') tooltip = 'Version History'

    return (
      <div
        className={classNames(
          'editor-left-nav-item',
          `editor-left-nav-item-${type}`,
          { active }
        )}
        onClick={this.handleClick}
      >
        <div className="editor-left-nav-item-sub">
          <Icon type={icon} />
        </div>
        <div className="editor-left-nav-tooltip">{capitalize(tooltip)}</div>
      </div>
    )
  }
}

class AddButton extends Component {
  handleClick = () => {
    const { onClick } = this.props

    onClick(ADD)
  }

  render() {
    const { active } = this.props

    return (
      <div
        className={classNames('editor-left-nav-add-button', { active })}
        onClick={this.handleClick}
      >
        <div className="editor-left-nav-add-button-sub" />
      </div>
    )
  }
}

export const mapStateToProps = state => ({
  activeTab: getActiveTab(state),
  selection: getSelection(state),
})

export default withRouter(connect(mapStateToProps, { setActiveTab })(LeftNav))
